// extracted by mini-css-extract-plugin
module.exports = {"PercentGauge":"PercentGauge__2QedfsprzAXr","previousPeriod":"previousPeriod__1WXnIeHHYoSI","Info":"Info__2f_GvGSL792k"};